export const FOLDERS_SEPARATOR_BACKEND = '\xa0'
export const FOLDERS_SEPARATOR_DISPLAY = '\\'
export const FOLDERS_SEPARATOR_ESCAPE_WRAPPER_CHARACTER = '"'

export const ReportDragDropIDSeparator = '|'

export enum ReportDragDropIDs {
    DRAGGABLE_REPORT = 'draggable-report',
    DRAGGABLE_FOLDER = 'draggable-folder',
    DROPPABLE_FOLDER = 'droppable-folder',
    DROPPABLE_BIN = 'droppable-bin',
    DROPPABLE_ROOT = 'droppable-root'
}

export enum ReportDragDropClasses {
    DND_CONTAINER = 'dnd-container',
    DND_HEADING = 'dnd-droppable-heading',
    DND_CONTENT = 'dnd-droppable-content',
    DND_ROOT_WRAPPER = 'dnd-droppable-root-wrapper',
    DND_BIN = 'dnd-droppable-bin'
}
